import React from "react";
import "./navbar.css";

export default function Navbar() {
    const currentPath = window.location.pathname;

    const links = [
        { path: "/whyus", label: "Why Us" },
        { path: "/pictures", label: "Pictures" },
        { path: "/about", label: "About Us" },
    ];

    const foundIndex = links.findIndex(
        (link) => link.path === currentPath
    );

    const activeIndex = foundIndex === -1 ? 0 : foundIndex;

    return (
        <div className="navbar-wrapper">

            {/* Logo */}
            <img
                src="https://res.cloudinary.com/dsfhaqrhn/image/upload/v1779176167/logo_sandeepani_vidyalaya_tanjez.jpg"
                alt="Logo"
                className="logo"
            />

            {/* Navbar */}
            <nav className="navbar">
                <div
                    className="slider"
                    style={{
                        transform: `translateX(${activeIndex * 100}%)`,
                    }}
                />

                {links.map((link) => (
                    <a
                        key={link.path}
                        href={link.path}
                        className={`nav-link ${
                            currentPath === link.path ? "active" : ""
                        }`}
                    >
                        {link.label}
                    </a>
                ))}
            </nav>

        </div>
    );
}